export class ImageColorizeRequestModel {
  file : File | null=null;
}

export class ImageColorizeResponseModel {
  base64_image!:string;
  content_type!:string;

}
